import { type UUID } from '~/types/common';

import { type GetInvoiceAiModelsSettingsPayload } from './useQueryInvoiceAiModelsSettings';

/**
 * Query key factory for invoice AI model settings-related queries.
 */
export const queryKeysInvoiceAiModel = {
  base: () => 'invoiceAiModelSettings' as const,
  getSettings: (invoiceAiModelSettingsId: UUID) =>
    [
      queryKeysInvoiceAiModel.base(),
      'settings',
      'details',
      invoiceAiModelSettingsId,
    ] as const,
  getAllSettings: (searchParams: GetInvoiceAiModelsSettingsPayload) =>
    [queryKeysInvoiceAiModel.base(), 'settings', 'list', searchParams] as const,
} as const;
